import React, { useState } from "react";
import { Link } from "react-router-dom";
import { LightningIcon } from "../shared/icons";
import SupportIntakeModal from "@/components/SupportIntakeModal";

const CTASection = ({ onMagneticMove, onMagneticLeave }) => (
  <div className="cta-section">
    <div className="cta-bg" />
    <div className="cta-inner">
      <div className="reveal">
        <span className="section-eyebrow" style={{ color: "var(--orange)" }}>
          Ready when you are
        </span>
        <h2 className="cta-h2">
          Run a business you control —
          <br />
          not one your <em>suppliers control.</em>
        </h2>
        <p className="cta-p">
          You didn&apos;t get into ecommerce to spend your evenings answering &ldquo;Where is my
          order?&rdquo; emails. Join 3,200+ sellers who replaced supplier chaos with systems they
          can actually rely on.
        </p>
        <div className="cta-btns">
          <a
            className="btn-hero-primary"
            href="#pricing"
            onMouseMove={onMagneticMove}
            onMouseLeave={onMagneticLeave}
          >
            <LightningIcon />
            Start free trial
          </a>
        </div>
        <p className="cta-note">14-day free trial · Cancel anytime · No setup fees</p>
      </div>
    </div>
  </div>
);

const LandingFooter = () => {
  const [supportOpen, setSupportOpen] = useState(false);

  return (
    <footer>
      <div className="footer-inner">
        <div
          className="footer-bottom"
          style={{
            borderTop: "1px solid #151515",
            paddingTop: 24,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div
            className="footer-logo"
            style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 0 }}
          >
            <img
              src="/images/logo.png"
              alt="Ecomdropship Logo"
              style={{ height: 40, width: 120, display: "block", objectFit: "contain" }}
            />
          </div>
          <div className="footer-copy">
            © {new Date().getFullYear()} Ecomdropship. All rights reserved.
          </div>
          <div style={{ display: "flex", gap: 20 }}>
            <button
              type="button"
              onClick={() => setSupportOpen(true)}
              style={{
                fontSize: 12,
                color: "#444",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
              }}
            >
              Help &amp; Support
            </button>
            <Link
              to="/privacy_policy"
              style={{ fontSize: 12, color: "#444", textDecoration: "none" }}
            >
              Privacy policy
            </Link>
            <Link
              to="/terms_services"
              style={{ fontSize: 12, color: "#444", textDecoration: "none" }}
            >
              Terms of service
            </Link>
          </div>
        </div>
      </div>
      <SupportIntakeModal
        open={supportOpen}
        onClose={() => setSupportOpen(false)}
      />
    </footer>
  );
};

export { CTASection, LandingFooter };
